import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { PAYMENTPAGE } from "npmlinks-constants";
import OtpV2 from "../../../OtpV2";

@inject("PaymentStore", "LoginStore", "WalletStore", "CheckoutStore")
@observer
class PaytmOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      generateOtpReqBody: {},
      validateOtpReq: {},
    };
    this.afterValidationCallBack = this.afterValidationCallBack.bind(this);
    this.afterGenerateOtpCallBack = this.afterGenerateOtpCallBack.bind(this);
  }

  /**
   *  TODO:: we are considering Primary mobile number if any other number( number is editable) is allowed
   *   for paytm wallet then we have to store this number in heimdall table and needs to get in getAllPaymentTypes
   *   Then only if balance is low we can on which new number Otp will go
   */
  componentDidMount() {
    const { mobileNumber, email: emailId } = this.props.LoginStore;
    this.setState({ generateOtpReqBody: { mobileNumber, emailId } });
  }

  afterGenerateOtpCallBack(generateOtpResponse) {
    const { mobileNumber } = this.props.LoginStore;
    const { state } = generateOtpResponse;
    const { total } = this.props.CheckoutStore.pricingOverviewData;
    const { selectedWallet } = this.props.WalletStore;
    if (generateOtpResponse) {
      this.setState({
        validateOtpReq: {
          mobileNumber,
          state,
          amount: total,
          walletName: this.props.WalletStore.selectedWalletCode,
        },
      });
    }
  }

  /**
   * @param walletInfo Object consist if [otp validation key  and  walletInfo]
   * i should get sendOTPFlag and balance of current wallet in validate only so that we can remove one extra call from UI
   */
  afterValidationCallBack(walletInfo) {
    const { walletDetails, otpvaildated } = walletInfo;
    if (otpvaildated) {
      this.props.WalletStore.updateSelectedWallet(walletDetails);
    }
  }

  render() {
    //{PAYMENTPAGE.OTP_HEADING}
    //PAYMENTPAGE.OTP_SENT_MSG
    return (
      <OtpV2.component
        otpHeading={""}
        otpSubHeading={PAYMENTPAGE.PAYTM_OTP_SENT_MSG}
        throughService={PAYMENTPAGE.OTPTHROUGHSERVICE.HEIMDALL}
        generateOtpReqBody={this.state.generateOtpReqBody}
        validateOtpReq={this.state.validateOtpReq}
        afterGenerateOtpCallBack={this.afterGenerateOtpCallBack}
        afterValidationCallBack={this.afterValidationCallBack}
      />
    );
  }
}

PaytmOtp.wrappedComponent.propTypes = {
  WalletStore: PropTypes.shape({
    setSelectedWallet: PropTypes.func.isRequired,
    addMoneyInWallet: PropTypes.func.isRequired,
    updateSelectedWallet: PropTypes.func.isRequired,
    selectedWalletCode: PropTypes.string.isRequired,
    selectedWallet: PropTypes.shape({}).isRequired,
  }).isRequired,
  LoginStore: PropTypes.shape({
    mobileNumber: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    pricingOverviewData: PropTypes.shape({}).isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("PaymentStore", "LoginStore", "WalletStore", "CheckoutStore")(
    observer(component),
  );

const ProjectComponent = {
  getFinalComponent,
  wrapper: PaytmOtp.wrappedComponent,
  component: PaytmOtp,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentWallet/Paytm/PaytmOtp/index.js